import React, { useEffect, useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  CircularProgress,
  Pagination,
  Box,
} from '@mui/material';
import { getAuditActions } from "../../api";

const AuditActionTable = () => {
  const [audits, setAudits] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const fetchAudits = async (page) => {
    setLoading(true);
    try {
      const response = await getAuditActions({ page, limit : 10});
      setAudits(response.data.audits);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      console.error('Error fetching audits:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAudits(page);
  }, [page]);

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  if (loading) {
    return <CircularProgress />;
  }

  return (
    <Box>
      <TableContainer component={Paper}>
        <Typography variant="h6" sx={{ margin: 2 }}>
          Action Audit Logs
        </Typography>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Trigger Action</TableCell>
              <TableCell>Trigger Action ID</TableCell>
              <TableCell>Timestamp</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Details</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {audits.map((audit) => (
              <TableRow key={audit._id}>
                <TableCell>{audit.triggerAction}</TableCell>
                <TableCell>{audit.triggerActionId}</TableCell>
                <TableCell>{new Date(audit.timestamp).toLocaleString()}</TableCell>
                <TableCell>{audit.status}</TableCell>
                <TableCell>{audit.details}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: 2 }}>
        <Pagination
          count={totalPages}
          page={page}
          onChange={handlePageChange}
          color="primary"
        />
      </Box>
    </Box>
  );
};

export default AuditActionTable;
